import { toast } from "sonner";
import customFetch from "../util/config/axiosConfig";
import { gallary, GalleryMedia } from "../types/galleryType";
import { ApiResponse, BackendPage, FilterResult } from "../types/responseType";

const galleryApis = {
  // post
  postGalleryImage: async (payload: gallary) => {
    try {
      const response = await customFetch.post("/api/v1/media/add", payload);

      if (response.data.status === 1) {
        toast.success("Added successfully!");
      } else {
        toast.error(response.data.error || "Failed to upload");
      }

      return response.data;
    } catch (error: any) {
      const message =
        error?.response?.data?.error ||
        error?.response?.data?.data ||
        "Error while uploading";

      toast.error(message);
      throw error;
    }
  },

  // GET 
  getGallery: async (
    branchCode: string,
    schoolCode: string,
    page = 0,
    size = 10
  ): Promise<FilterResult<GalleryMedia>> => {
    try {
      const response = await customFetch.get<
        ApiResponse<BackendPage<GalleryMedia>>
      >("/api/v1/media/filter", {
        params: {
          branchCode,
          schoolCode,
          page,
          size,
        },
      });

      if (response.data.status !== 1) {
        throw new Error(
          response.data.error?.message || "Failed to fetch gallery"
        );
      }

      const data = response.data.data;

      return {
        results: data.content,
        page: {
          index: data.pageable.pageNumber,
          size: data.pageable.pageSize,
          total: data.totalElements,
          count: data.numberOfElements,
        },
      };
    } catch (error: any) {
      toast.error(
        error?.response?.data?.error?.message || "Error fetching gallery"
      );
      throw error;
    }
  },

  deleteImage: async (mediaId: number) => {
    try {
      const response = await customFetch.delete(`/api/v1/media/${mediaId}`);
      toast.success("Image removed successfully");
      return response.data;
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to remove Image");
    }
  },
};

export default galleryApis;
